export const PASSWORD_VALIDATION = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])(?=.{8,})/;
export const EMAIL_VALIDATION = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$/;
export const ONLY_LETTERS_VALIDATION = /^[a-zA-Z'-._ ]+$/;
export const FIRM_NAME_VALIDATION = /^[a-zA-Z'-.&_ ]*$/;
export const POSTAL_CODE_VALIDATION = /^[0-9]{5}(?:-[0-9]{4})?$/;
export const PHONE_NUMBER_VALIDATION = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})?([ .-]?)([0-9]{4})/;
